/**
 * @generated SignedSource<<4b87054a7fe7aae3260d655a6f15057a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type settingsAppCatalog_viewer$data = {
  readonly company: {
    readonly tier: TierType | null;
    readonly " $fragmentSpreads": FragmentRefs<"ToggleIsSSOMandatory_company">;
  } | null;
  readonly " $fragmentType": "settingsAppCatalog_viewer";
};
export type settingsAppCatalog_viewer$key = {
  readonly " $data"?: settingsAppCatalog_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"settingsAppCatalog_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsAppCatalog_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ToggleIsSSOMandatory_company"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a5c89931768d7ade2a2d029ee8c1ae00";

export default node;
